var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "320.000000pt",
    height: "320.000000pt",
    viewBox: "0 0 320.000000 320.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,320.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1539 3056 c-25 -6 -65 -27 -90 -44 -78 -56 -71 -46 -484 -762 -87 -151 -188 -327 -225 -390 -37 -63 -104 -180 -150 -260 -46 -80 -113 -197 -150 -260 -327 -565 -384 -667 -401 -721 -51 -163 7 -289 161 -352 l55 -22 1345 0 1345 0 55 22 c154 63 212 189 161 352 -17 54 -74 156 -401 721 -37 63 -104 180 -150 260 -46 80 -113 197 -150 260 -37 63 -138 239 -225 390 -417 723 -408 709 -490 765 -27 19 -70 39 -95 44 -54 13 -54 13 -111 -3z m189 -768 c22 -15 54 -49 69 -75 25 -43 28 -57 27 -133 0 -48 -17 -180 -37 -300 -36 -212 -59 -370 -72 -483 l-7 -58 -106 3 -107 3 -17 140 c-9 77 -33 235 -53 350 -68 392 -69 408 -11 492 49 71 102 95 197 91 62 -2 83 -8 117 -30z m-57 -1208 c48 -13 118 -75 140 -124 36 -80 19 -188 -39 -250 -38 -40 -118 -76 -172 -76 -54 0 -134 36 -172 76 -58 62 -75 170 -39 250 21 46 91 111 136 123 42 13 103 13 146 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.385aee9f.svg";
export { ForwardRef as ReactComponent };